import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TZDatePickClientTime } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/DateTimePicker';
/**
 * @class NCDateTimePicker
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCDateTimePicker
 * @label 时间
 *
 */
class NCDateTimePicker extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 禁用
         * @description 禁用
         */
        disabled: PropTypes.bool,
        /**
        * @title 展开
        * @description 展开
        */
        open: PropTypes.bool
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        disabled: false
    }

    render() {
        return (
            <TZDatePickClientTime {...this.props} />
        )
    }
}

export default NCDateTimePicker;
